// extracted by mini-css-extract-plugin
export default {"choice":"ChoicePage_choice__CdiSN","content":"ChoicePage_content__knMLg","card":"ChoicePage_card__lyB2R"};